import { createAction } from 'redux-actions';

export const getInvoices = createAction('GET_INVOICES');
export const getInvoicesSuccess = createAction('GET_INVOICES_SUCCESS', invoices => ({ invoices }));
export const getInvoicesFail = createAction('GET_INVOICES_FAIL', error => ({ error }));

export const getInvoiceById = createAction('GET_INVOICE_BY_ID', id => ({ id }));
export const getInvoiceByIdSuccess = createAction('GET_INVOICE_BY_ID_SUCCESS', invoice => ({ invoice }));
export const getInvoiceByIdFail = createAction('GET_INVOICE_BY_ID_FAIL', error => ({ error }));

export const updateInvoice = createAction('UPDATE_INVOICE', invoice => ({ invoice }));
export const updateInvoiceSuccess = createAction('UPDATE_INVOICE_SUCCESS', invoice => ({ invoice }));
export const updateInvoiceFail = createAction('UPDATE_INVOICE_FAIL', error => ({ error }));

export const addInvoice = createAction('ADD_INVOICE', invoice => ({ invoice }));
export const addInvoiceSuccess = createAction('ADD_INVOICE_SUCCESS', invoice => ({ invoice }));
export const addInvoiceFail = createAction('ADD_INVOICE_FAIL', error => ({ error }));

export const searchInvoices = createAction('SEARCH_INVOICES', query => ({ query }));
export const searchInvoicesSuccess = createAction('SEARCH_INVOICES_SUCCESS', invoices => ({ invoices }));
export const searchInvoicesFailure = createAction('SEARCH_INVOICES_FAILURE');
